import BVRatings from '../Page/BVRatings';

export default BVRatings;
